import React, { useState, useEffect } from "react";
import CheckoutOrderSummary from "../components/checkout/CheckoutOrderSummary";
import Form from "../components/utility/Form";
import { useCart } from "./CartContext";
import { useCurrency } from "../components/utility/CurrencyContext";

const Checkout = () => {
  const { cart } = useCart();
  const { getCurrencySymbol, convertPrice, currency } = useCurrency();

  const [localCart, setLocalCart] = useState([]);
  const [localShipping, setLocalShipping] = useState({});
  const [shippingAddress, setShippingAddress] = useState(() => {
    const savedAddress = JSON.parse(
      localStorage.getItem("shippingAddress")
    ) || {
      country: "",
      state: "",
      town: "",
      pin_code: "",
    };
    return {
      country: savedAddress.country === "0" ? "" : savedAddress.country,
      state: savedAddress.state === "0" ? "" : savedAddress.state,
      town: savedAddress.town === "0" ? "" : savedAddress.town,
      pin_code: savedAddress.pin_code === "0" ? "" : savedAddress.pin_code,
    };
  });

  useEffect(() => {
    const savedCart = JSON.parse(localStorage.getItem("cartItems")) || [];
    const savedShipping =
      JSON.parse(localStorage.getItem("shippingAddress")) || {};
    setLocalCart(savedCart);
    setLocalShipping(savedShipping);
  }, []);

  useEffect(() => {
  const savedShipping =
    JSON.parse(localStorage.getItem("shippingAddress")) || {};
  setLocalShipping(savedShipping);

  // Prefer the context cart; only fall back to localStorage if empty
  if (cart && cart.length > 0) {
    setLocalCart(cart);
  } else {
    const savedCart = JSON.parse(localStorage.getItem("cartItems")) || [];
    setLocalCart(savedCart);
  }
}, [cart]);

  const resolvedShipping =
    Object.keys(localShipping).length > 0 ? localShipping : shippingAddress;
  const resolvedCart = localCart.length > 0 ? localCart : cart;

  // Same tier logic as Table2.js getPriceForQuantity
const calculateItemPrice = (quantity, item) => {
  const qty = Number(quantity) || 1;

  let rawPrice;
  if (qty >= 10000 && item.price_10000plus) {
    rawPrice = item.price_10000plus;
  } else if (qty >= 5000 && item.price_5000_9999) {
    rawPrice = item.price_5000_9999;
  } else if (qty >= 1000 && item.price_1000_4999) {
    rawPrice = item.price_1000_4999;
  } else if (qty >= 250 && item.price_250_999) {
    rawPrice = item.price_250_999;
  } else if (item.price_1_249) {
    rawPrice = item.price_1_249;
  } else {
    rawPrice = 0;
  }

  const converted = convertPrice(Number(rawPrice) || 0); // per-100
  return converted / 100; // per-piece
};

  return (
    <div className="mx-auto max-w-65rem py-[5rem]">
      <div className="text-center">
        <section>
          <div className="mt-4">
            <div className="bg-white">
              <div className="text-left px-10" style={{ marginLeft: "200px" }}>
                <h1 className="text-2xl font-bold text-left">Checkout</h1>
                <span>Home / Checkout</span>
              </div>
              <div className="flex flex-wrap gap-10 lg:gap-6 justify-evenly">
                <div className="w-full lg:w-[65%] bg-white">
                  <div className="container mx-auto mt-6">
                    <Form
                      calculateItemPrice={calculateItemPrice}
                      getCurrencySymbol={getCurrencySymbol}
                      cart={resolvedCart}
                      shippingAddress={resolvedShipping}
                      setShippingAddress={setShippingAddress}
                    />
                  </div>
                </div>

                <div className="w-full lg:w-[30%]">
                  <CheckoutOrderSummary
                    calculateItemPrice={calculateItemPrice}
                    cart={resolvedCart}
                    getCurrencySymbol={getCurrencySymbol}
                    shippingAddress={resolvedShipping}
                    caddress={shippingAddress}
                    convertPrice={convertPrice}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Checkout;